/**
 * Оси карт статусов заказа. `order` — статус самого заказа,
 * `fulfillment` — статус выполнения (отгрузка/доставка).
 * Ось `payment` настраивается отдельно в модуле платежей.
 */
export const ORDER_STATUS_AXES = {
  ORDER: 'order',
  FULFILLMENT: 'fulfillment',
  PAYMENT: 'payment',
};

/**
 * Режим настройки статусов хранилища. `basic` — простая настройка (как было
 * раньше): без осей, карт и fulfillment; одна настройка двигает и order, и payment.
 * `advanced` — полный функционал (3 оси, карты, кастомные триггеры).
 * Отсутствие поля трактуем как `basic` (безопасно для существующих хранилищ).
 */
export const ORDER_STATUS_MODES = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
};

/**
 * Расширенный ли режим статусов. Абсент/неизвестное → false (basic).
 */
export const isAdvancedStatusMode = (mode) => mode === ORDER_STATUS_MODES.ADVANCED;

/**
 * Триггеры жизненного цикла заказа, на которые можно назначить статус
 * в карте статусов. Сгруппированы по доменам (заказ/оплата/возврат) —
 * группировка используется только для отрисовки заголовков в редакторе,
 * на бэкенд уходит плоский `statusMap: { <trigger>: <statusIdentifier> }`.
 */
export const ORDER_STATUS_TRIGGER_GROUPS = [
  {
    key: 'order',
    triggers: ['order.created', 'order.products_changed'],
  },
  {
    key: 'payment',
    triggers: [
      'payment.link_created',
      'payment.waiting',
      'payment.partially_paid',
      'payment.paid',
      'payment.expired',
      'payment.canceled',
    ],
  },
  {
    key: 'refund',
    triggers: ['refund.pending', 'refund.partial', 'refund.full'],
  },
];

/**
 * Плоский список всех триггеров — удобно для фильтрации/валидации
 * (например, чтобы отбросить из statusMap ключи, которых нет в списке).
 */
export const ORDER_STATUS_TRIGGERS = ORDER_STATUS_TRIGGER_GROUPS.flatMap(
  (group) => group.triggers,
);

/**
 * Триггеры карты оси payment (модуль платежей). Отдельный набор: ось payment
 * двигается только платёжными событиями, поэтому `order.*` и `payment.link_created`
 * сюда не входят (см. каталог StatusTrigger, колонка «payment карта»).
 */
export const PAYMENT_AXIS_TRIGGER_GROUPS = [
  {
    key: 'payment',
    triggers: [
      'payment.waiting',
      'payment.partially_paid',
      'payment.paid',
      'payment.expired',
      'payment.canceled',
    ],
  },
  {
    key: 'refund',
    triggers: ['refund.pending', 'refund.partial', 'refund.full'],
  },
];

export const PAYMENT_AXIS_TRIGGERS = PAYMENT_AXIS_TRIGGER_GROUPS.flatMap(
  (group) => group.triggers,
);
